import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonDateRangeInput } from 'components/common/form/date/range';
import { endOfDay, endOfToday, startOfDay } from 'date-fns';
import { t } from 'i18next';
import { IMachineSettingsDateFilter } from 'interfaces/i-machine-settings';
import { LOCAL_DATEPICKER_FORMAT } from 'lib_ts/enums/datetime.enums';
import { useState } from 'react';

const MAX_DATE = endOfToday();

export const MachineSettingsDateRangeInput = ({
  dateRange,
  onChange,
  optional = true,
  showTime = false,
}: {
  dateRange?: IMachineSettingsDateFilter;
  onChange: (dateRange?: IMachineSettingsDateFilter) => void;
  optional?: boolean;
  showTime?: boolean;
}) => {
  const [key, setKey] = useState(Date.now());
  return (
    // TODO: refactor date range input entirely and/or just use a robust 3rd party library
    <CommonDateRangeInput
      id="date-range"
      key={key}
      displayFormat={LOCAL_DATEPICKER_FORMAT}
      maxDate={MAX_DATE}
      placeholder="Date Range"
      defaultStartValue={dateRange?.start}
      defaultEndValue={dateRange?.end}
      onChange={(values) => {
        // force re-mount to reset internal state
        setKey(Date.now());
        if (!values) {
          NotifyHelper.warning({
            message_md: t('common.check-inputs-msg'),
          });
          return;
        }

        if (!values.start && !values.end) {
          onChange(undefined);
          return;
        }

        if (!values.start || !values.end) {
          return;
        }

        if (showTime) {
          onChange({
            start: values.start,
            end: values.end,
          });
          return;
        }

        onChange({
          start: startOfDay(values.start),
          end: endOfDay(values.end),
        });
      }}
      onChangeOnClose
      optional={optional}
      showTime={showTime}
      skipSelectDateWarning
    />
  );
};
